export default __webpack_public_path__ + "static/media/pointer-right.9b54fa58.svg";